import styled, {css, keyframes} from 'styled-components';
import {
  BREAKPOINTS,
  COLORS,
  ComponentMStyling,
  ComponentSStyling,
  ComponentTextStyle,
  ComponentXSStyling,
  focusStyles,
  scrollBarStyling,
  Z_INDEXES
} from '../../styles';
import {Size} from '../../types';

export const RowLayout = styled.div`
  display: flex;
  align-items: center;
`;

export const Button = styled.button`
  background-color: ${props => COLORS.getColor('white', props.theme)};
  font-weight: bold;
  border: 0;
`;

const flowLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const flowRight = keyframes`
  0% {
    opacity: 1;
    transform: translateX(0);
    visibility: visible;
  }
  to {
    opacity: 0;
    visibility: hidden;
    transform: translateX(100%);
  }
`;


export const fadeOut = keyframes`
  0% {
    opacity: 1;
    visibility: visible;
  }
  to {
    opacity: 0;
    visibility: hidden;
  }
`;

export const fadeIn = keyframes`
  0% {
    opacity: 0;
    visibility: hidden;
  }
  to {
    opacity: 1;
    visibility: visible;
  }
`;

export const Menu = styled.div`
  height: 100%;
  background-color: ${props => COLORS.getColor('white', props.theme)};
  box-sizing: border-box;
  right: 0;
  top: 0;
  position: absolute;
  z-index: ${Z_INDEXES.off_canvas};
  align-items: center;

  width: 320px;

  ${BREAKPOINTS.SMALL} {
    width: 400px;
  }

  .open & {
    visibility: visible;
    display: flex;
    animation: ${flowLeft} 0.3s ease-in-out;
  }

  .closed & {
    visibility: hidden;
    animation: ${flowRight} 0.3s ease-in-out;
  }
`;

export const Right = styled.div`
  display: flex;
  margin-left: auto;
`;

export const SiteName = styled.span`
  color: ${props => COLORS.getColor('neutral_600', props.theme)};
  font-weight: bold;
  font-size: 14px;
  margin-left: 4px;
`;

export const MenuSection = styled.li`
  margin-top: 16px;

  .disabled-link {
    color: #21212150;
    pointer-events: none;
    key-events: none;
  }
`;

export const MenuSectionList = styled.ul`
  list-style: none;
  padding: 0;

  li {
    width: 80%;
    height: 48px;
    margin: 0 auto 0 12px;

    a {
      height: 100%;
    }
  }
`;

export const UserMenuSectionListStyling = css`
  li {
    position: relative;
  }

  li:hover:not(.disabled) {
    z-index: ${Z_INDEXES.hover};
    background-color: ${props => COLORS.getColor('primary_20', props.theme)};

    a {
      color: ${props => COLORS.getColor('primary_600', props.theme)};
    }

    svg {
      color: ${props => COLORS.getColor('primary_600', props.theme)};
    }
  }

  li:focus-within:not(.disabled) {
    z-index: ${Z_INDEXES.focus};

    ${focusStyles}
    a {
      outline: none;
    }
  }

  li:active:not(.disabled) {
    z-index: ${Z_INDEXES.active};
    background: ${props => COLORS.getColor('primary_100', props.theme)};

    a {
      color: ${props => COLORS.getColor('primary_800', props.theme)};
    }

    svg {
      color: ${props => COLORS.getColor('primary_800', props.theme)};
    }
  }

  .disabled {
    a {
      color: ${props => COLORS.getColor('neutral_300', props.theme)};
    }

    svg {
      color: ${props => COLORS.getColor('neutral_300', props.theme)};
    }

    background-color: ${props => COLORS.getColor('neutral_100', props.theme)};
  }
`;


export const flowDown = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const MobileMenuWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  flex-flow: column;
  display: flex;
  flex: 1;
  overflow: hidden;
`;

export const ScrollableContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 100%;

  &.scrollable {
    margin-right: 6px;
    padding-right: 10px;
  }

  ${scrollBarStyling(Size.Small)}
  ::-webkit-scrollbar-track {
    margin: 8px;
  }
`;

export const MobileHeaderText = styled.div`
  ${props => ComponentSStyling(ComponentTextStyle.Bold, COLORS.getColor('neutral_600', props.theme))}
  ${BREAKPOINTS.SMALL} {
    ${props => ComponentMStyling(ComponentTextStyle.Bold, COLORS.getColor('neutral_600', props.theme))}
  }
`;
export const MobileHeaderNote = styled.div`
  word-break: break-all;
  ${props => ComponentXSStyling(ComponentTextStyle.Regular, COLORS.getColor('neutral_600', props.theme))}
`;

export const MobileHeaderContainer = styled.div`
  margin: 0 24px;
  padding-bottom: 8px;
  box-sizing: border-box;
  border-bottom: 1px solid ${props => COLORS.getColor('neutral_200', props.theme)};
  display: flex;
  flex-direction: column;
`;
